module.exports = __webpack_public_path__ + "static/media/main-profile.67f22298.jpg";